import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { groupsService } from "../services/groups.service";
import type { GroupResponse } from "../types/groups.types";

export const useGroupsQuery = (options?: { enabled?: boolean }) =>
	useQuery({
		queryKey: ["groups"],
		queryFn: groupsService.getAll,
		staleTime: 5 * 60 * 1000,
		gcTime: 30 * 60 * 1000,
		enabled: options?.enabled ?? true,
		refetchOnMount: false,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});

export const useCreateGroupMutation = () => {
	const qc = useQueryClient();

	return useMutation({
		mutationFn: (name: string) => groupsService.create(name),
		onSuccess: async (newGroup) => {
			qc.setQueryData<GroupResponse[]>(["groups"], (old) => {
				if (!old) {
					return [newGroup];
				}

				if (old.some((group) => group.id === newGroup.id)) {
					return old;
				}

				return [...old, newGroup];
			});

			await qc.invalidateQueries({ queryKey: ["groups"] });
		},
	});
};
